import React from 'react';
import CrmContactTypesPage from '../components/CrmContactTypesPage';

const CrmContactTypesApp = (props) => (
  <CrmContactTypesPage {...props} />
);

export default CrmContactTypesApp;
